/*
  !IMPORTANT!: This file will be deleted in the future!
  If you want to use this functionality, please rather turn your *.vue file into a composition API and directly use the `useMobileDevice` composable instead.
  This file is only kept for backwards compatibility for old *.vue files that are still using options API and mixins.

  If you want to change the branding functionality, please do it in this mixin AND the composable!
*/
import { browserName, isMobile, mobileModel, mobileVendor, osName } from 'mobile-device-detect'

const isMobileDeviceMixing = {
  data: () => ({
    windowWidth: 0,
    windowHeight: 0,
    hasMobileSize: false
  }),
  methods: {
    onResize () {
      this.windowWidth = window.innerWidth
      this.windowHeight = window.innerHeight
    }
  },
  computed: {
    windowSize () {
      return { windowWidth: this.windowWidth, windowHeight: this.windowHeight }
    },
    isMobile () {
      return isMobile || this.isIpadOS
    },
    isIOSDevice () {
      return (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) || this.isIpadOS
    },
    isIpadOS () {
      return navigator && navigator.maxTouchPoints &&
        navigator.maxTouchPoints > 2 &&
        /MacIntel/.test(navigator.platform)
    },
    isMobileLandscape () {
      return this.hasMobileSize && this.windowWidth > this.windowHeight
    },
    // For modals, we only consider it as landscape if the width is greater than height + 150px. This is to ensure
    // that we don't prematurely set styles for landscape mode when the user is for example opening the soft keyboard
    // within a modal (which reduces the window size)
    isModalMobileLandscape () {
      return this.hasMobileSize && this.windowWidth > (this.windowHeight + 150)
    },
    mobileTrackingParams () {
      return { osName, browserName, mobileModel, mobileVendor }
    }
  },
  watch: {
    windowSize: {
      async handler (newWindowSize, oldWindowSize) {
        if (oldWindowSize?.windowWidth === newWindowSize?.windowWidth && oldWindowSize?.windowHeight === newWindowSize?.windowHeight) return

        await this.$nextTick()

        const { windowWidth, windowHeight } = newWindowSize

        if (windowWidth === 0 || windowHeight === 0) return this.hasMobileSize

        if (import.meta.env.IS_STORYBOOK) return this.hasMobileSize

        // We must not change the hasMobileSize state when the soft-keyboard is shown, since it reduces the screen size.
        // In this case we just return the previously saved state.
        if (this.$store.state.softKeyboardHeight > 0) return this.hasMobileSize

        // One of the dimensions is smaller than the mobile breakpoint (768px)
        // For the height, we also must take a possible keyboard height into account
        this.hasMobileSize = windowWidth <= 768 || Number(windowHeight + this.$store.state.softKeyboardHeight) <= 768
      }
    }
  },
  created () {
    this.onResize()
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  }
}

export default isMobileDeviceMixing
